<template>
  <div class="map-elem-info comment">
    <template v-if="state.mode === 'show'">
      <div class="col-icon">
        <img class="resource-icon" :src="iconPath">
      </div>
      <div class="col-info">
        <div class="row1 mb6">
          <div class="title-edit">
            <span class="ib vm comment-type ft-bold">
              【{{commentTypeDisp}}】
            </span>
            <span class="ib vm username-disp">
              {{state.comment.userDisplayName}}
            </span>
            <span class="ib vm share-scope" v-if="canModerateComment">
              ({{shareScopeDisp}})
            </span>
            <button
              type="button"
              key="msearch"
              class="btn btn-sm btn-secondary ml8"
              v-if="isParentComment"
              @click="doAreaMovieSearch"
            >
              <i class="fas fa-search mr2"></i>周辺の動画を検索
            </button>
            <div class="ib ml8" v-tooltip.right="copyLinkTooltip">
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                :disabled="!canCopyLink"
                @click="copyLink"
              >
                <i class="far fa-copy"></i>
              </button>
            </div>
          </div>
          <div class="ts ta-right mr8">
            {{dtFormat(state.comment.ts, 'yyyy/mm/dd HH:MM')}}
          </div>
        </div>
        <div class="row2 mb4">
          <div class="kp-info-disp" v-if="state.comment.kpUid">
            場所: {{kpDisp}}
          </div>
          <div class="angle-disp ml16" v-if="hasValidAngle">
            <span class="mr2">方角: {{state.comment.angle}}°</span>
            <div class="angle-arrow-wrap">
              <div class="angle-arrow-bg">
              </div>
              <div class="angle-arrow-img" :style="{ transform: `rotateZ(${state.comment.angle}deg)`}">
              </div>
            </div>
          </div>
          <div class="damage-rank-disp ml16" v-if="state.comment.damageRank">判定: {{state.comment.damageRank}}</div>
          <div class="spacer"></div>
          <div class="move-buttons mr4" v-if="showMoveButtons">
            <button class="btn btn-primary btn-xs mr4" @click="showPrevious">
              <i class="fas fa-arrow-left"></i>
              前へ
            </button>
            <button class="btn btn-primary btn-xs" @click="showNext">
              次へ
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
        <div class="row3">
          <div class="comment-content" v-html="contentDisp"></div>
        </div>
        <div class="row4 mt4 mb2">
          <div class="file-preview-area">
            <div v-for="file in sortedPreviewFiles" :key="file.id" class="file-box">
              <template v-if="isImageFileType(file.path)">
                <img :src="file.content" class="image" @click="showImage(file)" />
              </template>
              <template v-else>
                <i
                  class="far fa-3x"
                  :class="fileTypeIconFromFilePath(file.path)"
                  @click="downloadFile(file)"
                />
                <div class="file-name">
                  {{ file.name }}
                </div>
              </template>
            </div>
          </div>
          <div class="buttons ta-right mr8">
            <button
              type="button"
              key="edit"
              class="btn btn-sm btn-secondary"
              v-if="canModerateComment"
              @click="startEdit"
            >
              編集
            </button>
            <button
              type="button"
              key="delete"
              class="btn btn-sm btn-danger ml4"
              v-if="canModerateComment"
              @click="confirmDelete"
            >
              削除
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="state.mode === 'edit'">
      <div class="col-icon">
        <img class="resource-icon" :src="editIconPath">
      </div>
      <div class="col-info edit">
        <div class="row1 mb8">
          <div class="title-edit">
            <div class="form-group comment-type mb0 mr16">
              <span class="lbl">種別:</span>
              <select v-model="state.editItem.commentType" class="custom-select">
                <option v-for="e in masters.comment.commentTypes" :key="e.commentType" :value="e.commentType">
                  【{{e.commentTypeDisp}}】
                </option>
              </select>
            </div>
            <div class="form-group share-scope mb0 mr16">
              <span class="lbl">公開範囲:</span>
              <select v-model="state.editItem.shareScope" class="custom-select">
                <option v-for="e in masters.lov.shareScopes" :key="e.key" :value="e.key">
                  {{e.val}}
                </option>
              </select>
            </div>
            <div
              v-if="canUpdateTs"
              class="custom-control custom-checkbox mb0 mr16 mt6 update-ts-checkbox"
            >
              <input
                type="checkbox"
                id="update_ts"
                v-model="state.updateTs"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="update_ts">
                更新を通知
              </label>
            </div>
          </div>
        </div>
        <div class="row2 mb4">
          <div class="form-group road-kp mr16">
            <div>
              <span class="lbl">場所:</span>
              <select
                v-model="state.selectedKpObj"
                class="custom-select"
                :disabled="nearKps.length === 0"
                @change="onSelectedKpObjChanged"
              >
                <option value=""></option>
                <option v-for="(e, idx) in nearKps" :key="idx" :value="e">
                  {{ e.locationDisp }}
                </option>
              </select>
            </div>
            <div class="text-warning kp-warning" v-if="nearKps.length === 0">
              ※{{ nearKpThresholdMeters }}m以内にKPが見つかりませんでした
            </div>
          </div>
          <div class="form-group mr16">
            <div style="display:flex; align-items:center;">
              <span class="lbl">方角:</span>
              <input
                v-model="state.editItem.angle"
                type="number"
                min="-180"
                max="180"
                class="ib form-control ta-right angle"
              />
              <span class="ib ml2">°</span>
              <div class="angle-arrow-wrap ml6" v-if="editItemHasValidAngle">
                <div class="angle-arrow-bg">
                </div>
                <div class="angle-arrow-img" :style="{ transform: `rotateZ(${state.editItem.angle}deg)`}">
                </div>
              </div>
            </div>
          </div>
          <div class="form-group damage-rank mb0" v-if="hasDamageRank">
            <span class="lbl">判定:</span>
            <select v-model="state.editItem.damageRank" class="custom-select">
              <option :value="null" />
              <option v-for="code in COMMENT_DAMAGE_RANK_CODES" :key="code" :value="code">{{code}}</option>
            </select>
          </div>
        </div>
        <div class="row3">
          <div class="comment-content">
            <textarea
              class="comment-content-textarea"
              rows="4"
              placeholder="内容を入力してください"
              v-model="state.editItem.content"
            />
          </div>
        </div>
        <div class="row4 mt4 mb2">
          <div class="file-select-area">
            <template v-if="isFixedCandidateImages">
              <span class="lbl" v-if="state.candidateFiles.length > 1">
                添付画像を選択してください。
              </span>
              <span v-else>添付画像</span>
              <div class="file-preview-area mt6">
                <div
                  v-for="image in state.candidateFiles"
                  :key="image.id"
                  class="file-box"
                  :class="{ 'selected-image': image.selected }"
                >
                  <img :src="image.content" class="image" @click="selectImage(image)" />
                </div>
              </div>
            </template>
            <template v-else>
              <PreviewFilesArea
                :preview-files="sortedPreviewFiles"
                :is-changeable="true"
                :accepted-file-types="ACCEPTED_FILE_TYPES"
                @file-upload="handleFileUpload"
                @remove-file="removeFile"
              />
            </template>
          </div>
          <div class="buttons ta-right mr8">
            <button
              type="button"
              key="save"
              class="btn btn-sm btn-primary"
              :disabled="!canSave"
              @click="save"
            >
              保存
            </button>
            <button
              type="button"
              key="cancel"
              class="btn btn-sm btn-secondary ml4"
              v-if="showCancelButton"
              @click="cancelEdit"
            >
              キャンセル
            </button>
          </div>
        </div>
        <div class="form-group errors" v-if="state.errorMsgs.length > 0">
          <div class="error" :key="e" v-for="e in state.errorMsgs">{{e}}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { dtFormat } from 'src/lib/dateHelper';
import type { CommentEditProps, CommentEditEmit } from 'src/models/comment';
import PreviewFilesArea from 'src/components/lib/PreviewFilesArea/index.vue';
import { useCommentEdit } from './useCommentEdit';
import { useCommentDisplay } from './useCommentDisplay';
import { useReactiveMasters } from 'src/composables/useMasters';
import { COMMENT_DAMAGE_RANK_CODES } from 'src/consts/comment_damage_rank';

const props = withDefaults(defineProps<CommentEditProps>(), {
  isCreateSingleNewElement: false,
  forceShowCancelButton: false,
  updateFailed: 0,
  createFailed: 0,
  showMoveButtons: false,
});

const emit = defineEmits<CommentEditEmit>();
const { masters, resolveMastersPromise } = useReactiveMasters();

const {
  state,
  nearKps,
  commentKpObject,
  sortedPreviewFiles,
  startEdit,
  copyLink,
  showPrevious,
  showNext,
  confirmDelete,
  doAreaMovieSearch,
  onSelectedKpObjChanged,
  handleFileUpload,
  initDisplay,
  removeFile,
  save,
  showImage,
  cancelEdit,
  selectImage,
  nearKpThresholdMeters,
  fileTypeIconFromFilePath,
  isImageFileType,
  ACCEPTED_FILE_TYPES,
} = useCommentEdit(props, emit, masters);

const {
  iconPath,
  commentTypeDisp,
  shareScopeDisp,
  contentDisp,
  isParentComment,
  canModerateComment,
  canCopyLink,
  copyLinkTooltip,
  hasValidAngle,
  editIconPath,
  canUpdateTs,
  hasDamageRank,
  editItemHasValidAngle,
  isFixedCandidateImages,
  canSave,
  showCancelButton,
  kpDisp,
  downloadFile,
} = useCommentDisplay(props, state, masters, commentKpObject);

onMounted(async() => {
  await initDisplay();
  await resolveMastersPromise();
});
</script>

<style lang="scss"  scoped>
.col-icon {
  margin-right: 6px;
  .resource-icon {
    width: 42px;
  }
}
.col-info {
  .row1 {
    display: flex;
    flex-wrap: nowrap;
  }
  .row2, .row3, .row4 {
    display: flex;
    flex-wrap: wrap;
  }
  .row1, .row2 {
    justify-content: space-between;
  }
  .row2 {
    .spacer {
      flex-grow: 1;
    }
  }
  .row4 {
    flex-wrap: nowrap;
  }
  .lbl { margin-right: 4px; }
  .title {
    margin-left: -8px;
    flex-grow: 1;
  }
  .ts { width: 120px; }
  .comment-content {
    font-size: 0.8rem;
    flex-grow: 1;
  }
  .kp-info-disp {
    display: flex;
  }
  .angle-disp {
    display: flex;
  }
  .angle-arrow-wrap {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-top: -1px;
    position: relative;
    .angle-arrow-bg {
      position: absolute;
      width: 22px;
      height: 22px;
      top: 0;
      left: 0;
      background-image: url('/static/img/comment-angle-bg.png');
      background-size: cover;
    }
    .angle-arrow-img {
      position: absolute;
      width: 22px;
      height: 22px;
      top: 0;
      left: 0;
      background-image: url('/static/img/comment-angle.png');
      background-size: cover;
    }
  }
  .file-preview-area {
    display: flex;
    width: 100%;
    .file-box {
      cursor: pointer;
      position: relative;
      border: 4px solid #dddddd00;
      margin-left: 6px;
      .image {
        max-height: 72px;
        max-width: 128px;
      }
      i {
        color: red;
      }
      .fa-file-excel {
        color: #007234;
      }
      .fa-file-word {
        color: #2A5396;
      }
      .fa-file-powerpoint {
        color: #DE5B26;
      }
      .fa-file {
        color: black;
      }
      .file-name {
        font-size: smaller;
      }
    }
    .selected-image {
      border: 4px solid #f00;
    }
  }
  .buttons {
    width: 120px;
    min-width: 120px;
    align-self: flex-end;
  }

  &.edit {
    .row2 {
      justify-content: flex-start;
    }
    .title-edit {
      display: flex;
      flex: 1;
    }
    .comment-type, .share-scope, .damage-rank {
      .custom-select { width: 120px; }
    }
    .username-disp {
      margin-top: 6px;
    }
    .comment-content-textarea {
      width: 100%;
    }
    .angle-arrow-wrap {
      width: 32px;
      height: 32px;
      .angle-arrow-bg {
        width: 32px;
        height: 32px;
      }
      .angle-arrow-img {
        width: 32px;
        height: 32px;
      }
    }
    .update-ts-checkbox {
      margin-left: auto;
      white-space: nowrap;
    }
    .file-select-area {
      flex-grow: 1;
    }
    .buttons {
      width: 132px;
      align-self: flex-end;
    }
    .road-kp {
      .custom-select { width: 280px; }
    }
    .kp-warning {
      margin-left: 38px;
    }
    .angle {
      width: 70px;
    }
  }
  .errors { color: red; }
}
</style>
